import type { MilkdownPlugin } from "@milkdown/kit/ctx";

import { superscriptKeymap } from "../mark";

/// @internal
export const keymap: MilkdownPlugin[] = [
  superscriptKeymap.ctx,
  superscriptKeymap.shortcuts,
].flat();
